
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"46","height":"32","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M20.182 5H3.818C2.814 5 2 5.784 2 6.75v10.5c0 .966.814 1.75 1.818 1.75h16.364C21.186 19 22 18.216 22 17.25V6.75C22 5.784 21.186 5 20.182 5z","stroke":"currentColor","stroke-width":"1.4","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M4 10h16","stroke":"currentColor","stroke-width":"3","stroke-linecap":"square","stroke-linejoin":"round"}})])
          )
        }
      }
    